module.exports = __webpack_public_path__ + "img/img24.662d9f2b.jpg";